import { Container } from 'pixi.js';
import { RaceEventSmallRankFlagLayout } from '../../../../layouts/raceEvent/RaceEventSmallRankFlagLayout';
import { applyLayoutState } from '../../../libs/layouts/populateLayouts/applyLayoutState';

export class RaceEventIconRankFlagView extends Container {
  private readonly layout = new RaceEventSmallRankFlagLayout();

  constructor(rank: number) {
    super();

    this.layout.root.props({
      parent: this,
    });

    if (rank === 2) applyLayoutState(this.layout, '2nd');
    if (rank === 3) applyLayoutState(this.layout, '3rd');
    if (rank === 4) applyLayoutState(this.layout, '4th');
    if (rank === 5) applyLayoutState(this.layout, '5th');
    this.tweenFrom({ scaleXY: 0 }, 300, 'cubicOut', true);
  }
}
